export default __webpack_public_path__ + "static/media/MOQ-100.181be625.jpeg";